import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import RequestOtp from "./RequestOtp";
import ChangePin from "./ChangePin";
import httpClient from "../../../custom-hooks/httpClient";
import { useSelector } from "react-redux";

function UpdateTransactionPin() {
  const history = useHistory();
  const user = useSelector((state) => state.user.user);

  const [credentials, setCredentials] = useState({
    transaction_pin: "",
    confirm_transaction_pin: "",
    otp: "",
  });
  const [isRequestingOTP, setIsRequestingOTP] = useState(false);
  const [isSubmittingOtp, setisSubmittingOtp] = useState(false);
  const [stage, setStage] = useState("request-otp");
  const phoneNumber = user.phone_number

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleRequestOtp = (e) => {
    e.preventDefault();

    setIsRequestingOTP(true);
    httpClient
      .get(`/auth/get-otp?phone_number=${phoneNumber}`)
      .then(({ status, data }) => {
        setIsRequestingOTP(false);
        if (status === 200) {
          setStage("submit-otp");
        }
      })
      .catch((err) => {
        setIsRequestingOTP(false);
        toast.error(
          err && err.response
            ? err.response.data.message
            : "Error requesting OTP"
        );
      });
  };

  const handleSubmitOtp = (e) => {
    e.preventDefault();
    setisSubmittingOtp(true);
    const data = {
      ...credentials,
      phone_number: `${phoneNumber}`,
    };
    httpClient
      .post(`/users/${user.id}/reset-transaction-pin`, { data })
      .then(({ status, data }) => {
        setisSubmittingOtp(false);
        if (status === 200) {
          toast.success(data.message);
          history.push("/dashboard");
        }
      })
      .catch((err) => {
        setisSubmittingOtp(false);
        toast.error(
          err && err.response
            ? err.response.data.message
            : "Error requesting OTP"
        );
      });
  };

  return (
    <>
      <div className="col-12 col-md-9">
        <div className="card card-bleed shadow-light-lg mb-6">
          <div className="card-header">
            <div className="row">
              <div className="col text-center">
                <h2 className="mb-5">Update Transaction PIN</h2>
              </div>
              {stage === "request-otp" && (
                <RequestOtp
                  handleRequestOtp={handleRequestOtp}
                  isRequestingOTP={isRequestingOTP}
                />
              )}
              {stage === "submit-otp" && (
                <ChangePin
                  handleChange={handleChange}
                  handleSubmitOtp={handleSubmitOtp}
                  isSubmittingOtp={isSubmittingOtp}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateTransactionPin;
